import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed } from "@components/atoms/Themed"
import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue, useInnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Media Text",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/media-text", (props) => {
  const blocks = useInnerBlocks()
  const [body, setBody] = useInlineEditableValue("body", "")
  const hasBlocks = env.admin || (blocks && blocks.length > 0) || body !== ""

  return (
    <ScrollReveal>
      <div className="w-full py-7 my-10">
        <Themed theme={props.pageTheme || "none"} className="w-full py-7 relative isolate themed-fg">
          {/* Background color */}
          <div className="themed-bg absolute inset-0 -z-10" data-transition="fade" />

          {/* // Content */}
          <div className={cn("w-full max-w-grid mx-auto flex")}>
            <div
              className={cn(
                "w-full grid grid-cols-1 md:grid-cols-2 gap-7",
                props.style === "slim" && "md:grid-cols-3 gap-5",
              )}
            >
              <div
                className={cn(
                  "w-full rounded-full aspect-square overflow-hidden",
                  props.style === "slim" && "md:col-start-3",
                  props.alternate && "md:order-2",
                )}
                data-transition="scale"
              >
                {env.admin && !props.image?.mediaItemUrl && !props.video?.mediaItemUrl && (
                  <div className="w-full h-full bg-grey flex items-center justify-center type-label-m">
                    Select media
                  </div>
                )}
                {props.image && !props.video && (
                  <ResponsiveImage {...props.image} className="w-full h-full" objectFit="cover" />
                )}
                {!props.image && props.video?.mediaItemUrl && (
                  <video
                    src={props.video.mediaItemUrl}
                    className="w-full h-full object-cover object-center"
                    playsInline
                    autoPlay
                    muted
                    loop
                  />
                )}
              </div>
              <div
                className={cn(
                  "w-full p-7 self-stretch flex flex-col justify-center items-start gap-4 rounded-xl border-current border-2 border-solid",
                  props.style === "slim" &&
                    "md:col-start-1 md:col-end-3 md:row-start-1 bg-black text-white border-none",
                  props.alternate && "md:order-1",
                )}
                data-transition="scale"
              >
                <EditableText
                  as="p"
                  store="subtitle"
                  className="type-label-s-caps"
                  placeholder="Enter an optional subtitle"
                  data-transition="fade-up"
                />
                <EditableText
                  as="h2"
                  store="title"
                  className="type-title-s md:type-title-m text-balance md:w-11/12"
                  defaultValue="Enter a title"
                  data-transition="fade-up"
                />
                <div
                  className={cn("flex items-center flex-wrap gap-3 md:gap-2 mt-5 md:mt-1", !hasBlocks && "hidden")}
                  data-transition="children/fade"
                >
                  <EditableText
                    as="p"
                    store="body"
                    className="type-body-m mt-4 mb-3 block w-full"
                    placeholder="Enter an optional body text"
                    data-transition="fade-up"
                  />
                  {!props.hideButtons && (
                    <InnerBlocks
                      allowedBlocks={["content/button"]}
                      template={props.style === "slim" ? [] : [["content/button", {}]]}
                      orientation="horizontal"
                      adminClassName="flex items-center flex-wrap gap-5"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Themed>
      </div>
    </ScrollReveal>
  )
})
